import React, { useEffect } from 'react';
import { GIFS } from '../../assets/gifs';
import './loading-screen.scss';
import { getWorkspace, useAppSelector } from '@zonofi/zono-money-store';
import { isEmpty } from 'lodash';
export const LoadingScreen: React.FC = () => {
  // const workspace = useAppSelector(getWorkspace);

  // useEffect(() => {
  //   if (workspace && !isEmpty(workspace)) {
  //     window.location.href = 'seller/orders';
  //   }
  // }, [workspace]);

  return (
    <div className="loading-container">
      <img
        src={GIFS.LoaderGif}
        alt="loading"
        height={'120px'}
        width={'120px'}
      />
    </div>
  );
};
